/**
 * Aba Historico: a linha do tempo da CONTA (criada, integracoes, primeiro
 * webhook, primeira recuperacao, ajustes).
 *
 * E a unica parte do detalhe que NAO obedece a janela do cabecalho, de
 * proposito: e a biografia da empresa, e "conta criada" sumir num filtro de
 * 7 dias deixaria a historia sem comeco. O rodape diz isso por escrito.
 * Cor do evento nunca vai sozinha: cada item tem icone, titulo e data.
 */

import { Badge, Footnote, Icon, SectionCard } from '../../../components/ui';
import { formatDateTime } from '../../../lib/format';
import type { AccountEvent } from '../types';
import { EVENTO_CONTA } from '../vocabulario';

const FUNDO: Readonly<Record<AccountEvent['kind'], string>> = {
  criada: 'bg-brand/10 text-brand',
  integracao: 'bg-info/10 text-info',
  equipe: 'bg-ink/5 text-ink-muted',
  primeiro_webhook: 'bg-accent/10 text-accent',
  primeira_recuperacao: 'bg-status-good/10 text-status-good',
  ajuste: 'bg-ink/5 text-ink-muted',
};

export function AbaHistorico({ history, companyName }: { readonly history: readonly AccountEvent[]; readonly companyName: string }): JSX.Element {
  return (
    <SectionCard id="historico" title="Linha do tempo da conta" icon="relogio" description={`Do cadastro de ${companyName} até hoje, do mais recente para o mais antigo.`}>
      {history.length === 0 ? (
        <p className="py-8 text-center text-sm text-ink-muted">Nenhum evento registrado ainda.</p>
      ) : (
        <ol className="relative ml-4 flex flex-col gap-5 border-l border-line pl-6">
          {history.map((evento, i) => {
            const info = EVENTO_CONTA[evento.kind];
            return (
              <li key={evento.id} className="relative">
                <span aria-hidden="true" className={`absolute -left-10 top-0 grid h-8 w-8 place-items-center rounded-full border border-line bg-surface ${FUNDO[evento.kind]}`}>
                  <Icon name={info.icon} size="sm" />
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-sm font-semibold text-ink">{evento.title}</h3>
                  {i === 0 ? (
                    <Badge tone="neutral" dot>
                      Mais recente
                    </Badge>
                  ) : null}
                </div>
                <p className="mt-0.5 text-xs text-ink-subtle">
                  <time dateTime={evento.at}>{formatDateTime(evento.at)}</time>
                </p>
                <p className="mt-1 max-w-prose text-sm text-ink-muted">{evento.description}</p>
              </li>
            );
          })}
        </ol>
      )}
      <div className="mt-5">
        <Footnote>A linha do tempo cobre toda a vida da conta e não é recortada pelo período do cabeçalho.</Footnote>
      </div>
    </SectionCard>
  );
}
